<template>
  <v-slide-x-reverse-transition>
    <v-card raised class="elevation-5 rulecollection-details vop-bg-whisper" v-if="isVisible">
      <div>
        <!-- Toolbar -->
        <v-toolbar flat color="vop-bg-whisper">
          <!-- Title -->
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span>{{ messages.label.RULE_COLLECTION }} - {{ selectedRuleCollection.title }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Test button -->
          <v-btn color="secondary" @click="showTestRuleModal()" round small>
            {{ messages.label.TEST }}
          </v-btn>

          <!-- Close button -->
          <v-toolbar-items>
            <!-- Edit button -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon medium v-on="on" @click="goToEditView()" class="grey--text text--darken-2">
                  <v-icon>mdi-circle-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit Rule Collection</span>
            </v-tooltip>
            <!-- More Menu -->
            <v-menu offset-y left>
              <v-tooltip bottom slot="activator">
                <template v-slot:activator="{ on }">
                  <v-btn icon medium v-on="on" class="grey--text text--darken-2">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <span>More</span>
              </v-tooltip>
              <v-list>
                <v-list-tile @click="showCopyRuleModal()">
                  <v-list-tile-title>{{ messages.label.COPY_RULE_COLLECTION }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="showOverrideRuleModal()">
                  <v-list-tile-title>{{ messages.label.OVERRIDE_RULE_COLLECTION }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="error--text" @click="showDeleteDialog()">
                  <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <!-- Close button -->
            <v-btn icon @click="hide()">
              <v-icon medium>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- Main Content -->
        <v-card-text>
          <v-progress-linear :indeterminate="true" height="4" v-if="ruleCollectionLoading">
          </v-progress-linear>
          <!-- Error Alert -->
          <v-flex xs12 v-if="errorAlert">
            <v-alert v-model="errorAlert" dismissible type="error">
              {{ errorMessage }}
            </v-alert>
          </v-flex>
          <v-tabs v-model="activeTab" color="vop-bg-whisper" slider-color="primary">
            <v-tab v-for="item in tabItems" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-layout wrap>
            <v-flex xs12>
              <v-tabs-items v-model="activeTab">
                <v-tab-item>
                  <v-data-table :items="ruleCollectionDetails" hide-actions hide-headers class="mt-2">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left ttu" width="30%">{{ props.item.name | ownerLabel }}</td>
                      <td class="text-xs-left">
                        <!-- Inline Title Edit -->
                        <template v-if="props.item.name === 'title'">
                          <div>
                            <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                              @save="saveField(props.item.value, 'title')" @cancel="cancelInlineEdit">
                              <!-- Title Display -->
                              <div v-if="!$lodash.isEmpty(props.item.value)">
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                              </div>
                              <div v-else>
                                {{ messages.label.ADD_TITLE }}
                                <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                              </div>
                              <!-- Title Edit Input -->
                              <template v-slot:input>
                                <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                  {{ messages.label.UPDATE_TITLE }}
                                </div>
                                <div class="mt-3 subtitle ttu" v-else>{{ messages.label.ADD_TITLE }}
                                </div>
                                <v-text-field v-model="props.item.value" clearable v-validate="'required|max:100'"
                                  :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
                                  :label="messages.label.RULE_TITLE" single-line autofocus>
                                </v-text-field>
                              </template>
                            </v-edit-dialog>
                          </div>
                        </template>
                        <!-- Inline Description Edit -->
                        <template v-else-if="props.item.name === 'description'">
                          <div>
                            <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                              @save="saveField(props.item.value, 'description')" @cancel="cancelInlineEdit">
                              <!-- Description Display -->
                              <div v-if="!$lodash.isEmpty(props.item.value) && !$lodash.isNull(props.item.value)">
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                              </div>
                              <div v-else>
                                {{ messages.label.ADD_DESCRIPTION }}
                                <v-icon small class="ml-2" color="primary">add_circle</v-icon>
                              </div>
                              <!-- Description Edit Input -->
                              <template v-slot:input>
                                <div class="mt-3 subtitle ttu" v-if="!$lodash.isEmpty(props.item.value)">
                                  {{ messages.label.UPDATE_DESCRIPTION }}
                                </div>
                                <div class="mt-3 subtitle ttu" v-else>{{ messages.label.ADD_DESCRIPTION }}
                                </div>
                                <v-textarea v-model="props.item.value" clearable v-validate="'max:500'"
                                  :error-messages="errors.collect('description')" data-vv-name="description"
                                  :counter="500" :label="messages.label.RULE_DESCRIPTION" single-line autofocus>
                                </v-textarea>
                              </template>
                            </v-edit-dialog>
                          </div>
                        </template>
                        <!-- Inline Enabled status edit -->
                        <template v-else-if="props.item.name === 'enabled'">
                          <div>
                            <div>
                              <v-edit-dialog :return-value.sync="props.item.value" large lazy persistent
                                @save="saveField(props.item.value, 'enabled')" @cancel="cancelInlineEdit">
                                <!-- Enabled Status Display -->
                                {{ props.item.value }}
                                <v-icon small class="ml-2" color="primary">mdi-circle-edit-outline</v-icon>
                                <!-- Description Edit Input -->
                                <template v-slot:input>
                                  <div class="mt-3 subtitle ttu">
                                    {{ messages.label.UPDATE_ENABLED }}
                                  </div>
                                  <v-switch v-model="props.item.value" class="mt-0" hide-details color="primary"
                                    :label="`${(props.item.value).toString()}`">
                                  </v-switch>
                                </template>
                              </v-edit-dialog>
                            </div>
                          </div>
                        </template>
                        <!-- Owner -->
                        <template v-else-if="props.item.name === 'ownerId'">
                          {{ getOwnerName(props.item.value) }}
                        </template>
                        <!-- Provider -->
                        <template v-else-if="props.item.name === 'secondaryOwner'">
                          {{ getProviderName(props.item.value) }}
                        </template>
                        <template v-else>
                          <div>
                            {{ props.item.value }}
                          </div>
                        </template>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <!-- Rule Sets -->
                <v-tab-item>
                  <v-data-table :headers="ruleSetHeaders" :items="ruleSets" class="mt-1" ref="draggableTable">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="handle" style="max-width: 28px" v-if="displayDragHandle">
                          <v-icon>drag_handle</v-icon>
                        </td>
                        <td class="text-xs-center" v-if="displayDragHandle">{{ props.item.sequence + 1 }}</td>
                        <td class="text-xs-left" width="35%">
                          <v-btn flat icon color="primary" @click="props.expanded = !props.expanded">
                            <v-icon>{{ props.expanded ? 'remove_circle' : 'add_circle' }}</v-icon>
                          </v-btn>
                          {{ props.item.title }}
                        </td>
                        <td class="text-xs-left" width="12%">{{ getProviderName(props.item.secondaryOwner) }}</td>
                        <td class="text-xs-left" width="12%">Rule Set</td>
                        <td class="text-xs-left" width="12%">{{ !props.item.disabled }}</td>
                        <td class="text-xs-left">{{ props.item._updated }}</td>
                        <td @click.stop="stopProp">
                          <v-menu bottom left>
                            <v-btn icon slot="activator">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
                              <v-list-tile @click="openRuleSetQuickView(props.item)">
                                <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                                <v-icon small right>
                                  open_in_new
                                </v-icon>
                              </v-list-tile>
                              <v-list-tile>
                                <v-list-tile-title>{{ messages.label.COPY_TO }}</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="goToEditRuleSetView(props.item)">
                                <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>
                    </template>
                    <!-- Expanded view-->
                    <template slot="expand" slot-scope="props">
                      <v-data-table hide-actions hide-headers :items="props.item.rules">
                        <template slot="items" slot-scope="props">
                          <!-- <tr class="indigo lighten-5 ml-3 expandableRows"> -->
                          <!-- Place empty column for the alignment with sequence -->
                          <td class="text-xs-left" width="12%"></td>
                          <td class="text-xs-left" width="35%">
                            <!-- Place holder button to fix the alignment -->
                            <v-btn flat disabled icon>
                              <v-icon small>trip_origin</v-icon>
                            </v-btn>
                            {{ props.item.title }}
                          </td>
                          <td class="text-xs-left" width="12%">{{ getProviderName(props.item.secondaryOwner) }}</td>
                          <td class="text-xs-left" width="12%">Rule</td>
                          <td class="text-xs-left" width="12%">{{ !props.item.disabled }}</td>
                          <td class="text-xs-left">{{ props.item._updated }}</td>
                          <td @click.stop="stopProp" class="text-xs-center">
                            <v-menu bottom left>
                              <v-btn icon slot="activator">
                                <v-icon>more_vert</v-icon>
                              </v-btn>
                              <v-list>
                                <v-list-tile @click="openRuleQuickView(props.item)">
                                  <v-list-tile-title>{{ messages.label.VIEW_DETAILS }}</v-list-tile-title>
                                  <v-icon small right>
                                    open_in_new
                                  </v-icon>
                                </v-list-tile>
                                <v-list-tile>
                                  <v-list-tile-title>{{ messages.label.COPY_TO }}</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="goToEditRuleView(props.item)">
                                  <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </td>
                          <!-- </tr> -->
                        </template>
                        <template slot="no-data">
                          <v-alert :value="true" color="info" class="black--text" icon="info">
                            {{ messages.info.NO_RULES }}
                          </v-alert>
                        </template>
                      </v-data-table>
                    </template>
                    <!-- No Data -->
                    <template slot="no-data">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_RULE_SETS }}
                      </v-alert>
                    </template>
                    <!-- No Results -->
                    <template slot="no-results">
                      <v-alert :value="true" color="info" class="black--text" icon="info">
                        {{ messages.info.NO_FILTER_RESULTS }}
                      </v-alert>
                    </template>
                  </v-data-table>
                  <v-btn color="primary" v-if="displayUpdateRuleSetsSequenceButton" :disabled="updatingRuleCollection"
                    :loading="updatingRuleCollection" @click="updateRuleSetsSequence">
                    {{ messages.label.SAVE }}
                  </v-btn>
                </v-tab-item>
                <v-tab-item>
                  <JSONView :json="selectedRuleCollectionJSON" />
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <!-- Delete Dialog -->
        <v-dialog v-model="deleteDialog" width="500">
          <v-card>
            <v-card-title class="subheading ttu">
              {{ messages.label.DELETE }}
            </v-card-title>
            <v-card-text>
              <!-- Error Alert -->
              <v-flex xs12 v-if="deleteErrorAlert">
                <v-alert v-model="deleteErrorAlert" type="error">
                  {{ deleteErrorMessage }}
                </v-alert>
              </v-flex>
              <p>{{ messages.info.DELETE_RULE_1 }} <b>{{ selectedRuleCollection.title }}</b> ? </p>
              <p v-html="messages.info.DELETE_RULE_2"></p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-1 white--text" @click="cancelDelete">
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" :disabled="deletingRule" :loading="deletingRule" @click="deleteRule()">
                {{ messages.label.YES }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
      <!-- Rule Test Dialog -->
      <MetadataRuleTest v-model="ruleTestDialog" :rule-obj="ruleObjectToTest" />
      <!-- Rule Copy Dialog -->
      <MetadataRuleCopy v-model="ruleCopyDialog" :rule-obj="ruleObjectToCopy" />
      <!-- Rule Override Dialog -->
      <MetadataRuleOverride v-model="ruleOverrideDialog" :rule-obj="ruleObjectToOverride" />
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
        </v-snackbar>
      </v-flex>
      <!-- Dialogs -->
      <v-dialog v-model="ruleQuickViewDialog" width="1000" height="800">
        <RuleQuickView />
      </v-dialog>
      <v-dialog v-model="ruleSetQuickViewDialog" width="1000" height="800">
        <RuleSetQuickView />
      </v-dialog>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import * as metadataRulesDataService from "@/MetadataRules/MetadataRulesDataService"
import * as utils from "@/Shared/utils"
import messages from "@/MetadataRules/messages.json"
import JSONView from "@/MetadataRules/JSONView"
import MetadataRuleTest from "@/MetadataRules/MetadataRuleTest"
import RuleQuickView from "@/MetadataRules/Rule/RuleQuickView"
import RuleSetQuickView from "@/MetadataRules/RuleSet/RuleSetQuickView"
import MetadataRuleCopy from "@/MetadataRules/MetadataRuleCopy"
import { IS_POLARIS, MVATS_WEB_SERVICE_URL, RULE_MGMT_DATA_SERVICE_URL } from "@/store/constants/getter-types"
import MetadataRuleOverride from "@/MetadataRules/MetadataRuleOverride"
import Sortable from "sortablejs"

export default {
  name: "RuleCollectionQuickView",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    RuleQuickView,
    RuleSetQuickView,
    JSONView,
    MetadataRuleTest,
    MetadataRuleCopy,
    MetadataRuleOverride
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: 3000,
        color: "error",
        message: ""
      },
      activeTab: null,
      ruleObjectToTest: {},
      ruleObjectToCopy: {},
      ruleObjectToOverride: {},
      ruleTestDialog: false,
      ruleCopyDialog: false,
      ruleOverrideDialog: false,
      tabItems: ["DETAILS", "RULE SETS", "{JSON}"],
      selectedRuleCollection: {},
      selectedRuleCollectionJSON: {},
      isVisible: false,
      ruleSets: [],
      originalRuleSets: [],
      rules: [],
      ruleCollectionDetails: [],
      errorAlert: false,
      errorMessage: "",
      ruleCollectionLoading: false,
      expand: true,
      deleteDialog: false,
      deletingRule: false,
      deleteErrorAlert: false,
      deleteErrorMessage: "",
      ruleQuickViewDialog: false,
      ruleSetQuickViewDialog: false,
      updatingRuleCollection: false,
      dictionary: this.getValidationDictionary()
    }
  },
  computed: {
    ...mapState([
      "mpxParentAccount", "providerGroups", "mpxSubAccounts"
    ]),
    ...mapGetters([
      IS_POLARIS, MVATS_WEB_SERVICE_URL, RULE_MGMT_DATA_SERVICE_URL
    ]),
    ruleSetHeaders() {
      return this.getRuleSetHeaders()
    },
    /**
     * displayDragHandle  - identify if sequence handle needs to be displayed
     * @returns {boolean}
     */
    displayDragHandle() {
      let display = false
      if (!this.$lodash.isUndefined(this.selectedRuleCollection) &&
        this.selectedRuleCollection.type === "TRANSFORMATION") {
        display = true
        this.$nextTick(() => {
          let table = this.$refs.draggableTable.$el.getElementsByTagName("tbody")[0]
          const _self = this
          Sortable.create(table, {
            handle: ".handle", // Use handle so user can select text
            onEnd({ newIndex, oldIndex }) {
              oldIndex = oldIndex / 2
              newIndex = newIndex / 2
              let rowSelected = _self.ruleSets.splice(oldIndex, 1)[0] // Get the selected row and remove it
              _self.ruleSets.splice(newIndex, 0, rowSelected) // Move it to the new index
              _self.resetRuleSetsSequenceNumbers()
              _self.sortRuleSetsOnSequence()
            }
          })
        })
      }
      return display
    },
    /**
     * displayUpdateRuleSetsSequenceButton  - identify if user has changed the sequence of ruleSets within rulecollection
     * @returns {boolean}
     */
    displayUpdateRuleSetsSequenceButton() {
      let display = false
      let ruleSetsArray = []
      if (this.ruleSets.length > 0) {
        this.$lodash.forEach(this.ruleSets, (object, index) => {
          // Remove sequence field before comparing
          object = this.$lodash.omit(object, ["sequence"])
          ruleSetsArray[index] = object
        })
      }
      if (JSON.stringify(ruleSetsArray) !== JSON.stringify(this.originalRuleSets)) {
        display = true
      }
      return display
    }
  },
  methods: {
    /**
    * show - Show ruleset details view
    * @param {object} selectedRuleCollection
    */
    show(selectedRuleCollection) {
      this.resetData()
      this.selectedRuleCollection = selectedRuleCollection
      this.selectedRuleCollectionOriginal = this.$lodash.cloneDeep(this.selectedRuleCollection)
      this.selectedRuleCollectionJSON = {}
      this.retrieveRuleCollection()
      if (!this.isVisible) { // If already visible, leave tab selection as is
        this.isVisible = true
        this.activeTab = 0
      }
    },

    /**
    * resetData - Reset data
    */
    resetData() {
      this.errorAlert = false
      this.errorMessage = ""
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters"
          },
          description: {
            max: "Description may not be greater than 100 characters"
          }
        }
      }
    },

    /**
     * getRuleSetHeaders - Construct array of objects to show table headers
     * @return {array}
     */
    getRuleSetHeaders() {
      let headerToDisplay = []
      if (this.displayDragHandle) {
        headerToDisplay = [{
          text: "",
          align: "left",
          sortable: false
        },
        {
          text: "SEQUENCE",
          align: "center",
          value: "sequence",
          sortable: true
        },
        {
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        }]
      } else {
        headerToDisplay = [{
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        }]
      }
      let commonHeaders = [
        {
          text: messages.label.TH_PROVIDER,
          sortable: false,
          align: "left",
          value: "secondaryOwner"
        },
        {
          text: messages.label.TH_TYPE,
          sortable: false,
          align: "left"
        },
        {
          text: messages.label.TH_ENABLED,
          sortable: false,
          align: "left",
          value: "enabled"
        },
        {
          text: messages.label.TH_UPDATED,
          sortable: false,
          align: "left",
          value: "updated"
        },
        {
          text: "",
          sortable: false
        }
      ]
      headerToDisplay = headerToDisplay.concat(commonHeaders)
      return headerToDisplay
    },
    /**
     * retrieveRuleSet  - retrieve rule list details
     * This service call will retrieve all the rule collection details along with rulesets list
     */
    retrieveRuleCollection() {
      this.ruleCollectionLoading = true
      let queryObject = {
        ruleCollectionGuid: this.selectedRuleCollection.guid,
        account: this.selectedRuleCollection.ownerId,
        secondaryOwner: this.selectedRuleCollection.secondaryOwner
      }
      metadataRulesDataService
        .getRuleCollectionDetails(queryObject, this.MVATS_WEB_SERVICE_URL)
        .then((response) => {
          // Add the client only fields to this object as well
          this.selectedRuleCollectionJSON = this.$lodash.cloneDeep(response.data)
          let tempArray = []
          tempArray.push(response.data)
          tempArray = MetadataRulesService.addClientOnlyFields(tempArray)
          this.selectedRuleCollection = tempArray[0]
          this.constructRuleCollectionDetails()
          this.ruleSets = MetadataRulesService.addClientOnlyFields(this.selectedRuleCollection.ruleSetDetails)
          // Add client side fields for rule objects
          if (this.ruleSets.length > 0) {
            this.$lodash.forEach(this.ruleSets, (ruleSet) => {
              if (ruleSet.rules.length > 0) {
                ruleSet.rules = MetadataRulesService.addClientOnlyFields(ruleSet.rules)
              }
            })
          }
          this.originalRuleSets = this.$lodash.cloneDeep(this.ruleSets)
          this.resetRuleSetsSequenceNumbers()
        })
        .catch((error) => {
          let isServerError = utils.isMPXError(error)
          let isClientError = utils.isClientError(error)
          if (isServerError) {
            this.errorAlert = true
            this.errorMessage = error.response.data.description
          } else if (isClientError) {
            this.errorAlert = true
            this.errorMessage = error.message
          }
        })
        .finally(() => {
          this.ruleCollectionLoading = false
        })
    },

    /**
     * Reset / update sequence numbers for ruleSets within rule collection
     */
    resetRuleSetsSequenceNumbers() {
      if (this.ruleSets.length > 0) {
        this.$lodash.forEach(this.ruleSets, (ruleSet, index) => {
          ruleSet["sequence"] = index
        })
      }
    },

    /**
     * Sort ruleSets within rule collection based on sequence number
     */
    sortRuleSetsOnSequence() {
      if (this.ruleSets.length > 0) {
        let sortedList = this.$lodash.sortBy(this.ruleSets, "sequence")
        this.ruleSets = []
        this.$nextTick(() => {
          this.ruleSets = sortedList
        })
      }
    },

    /**
     * constructRuleCollectionDetails - Construct selected rule details
     * This is being done to display in a data table
     */
    constructRuleCollectionDetails() {
      this.ruleCollectionDetails = []

      let requiredFields = ["title", "type", "description", "_enabled", "ownerId", "providerGroup", "secondaryOwner", "_added", "_updated"]
      requiredFields.forEach((fieldName) => {
        let obj = {}
        if (this.selectedRuleCollection.hasOwnProperty(fieldName)) {
          obj["name"] = fieldName.charAt(0) === "_" ? fieldName.substring(1) : fieldName
          obj["value"] = this.selectedRuleCollection[fieldName]
          this.ruleCollectionDetails.push(obj)
        } else if (fieldName === "providerGroup") {
          if (this.IS_POLARIS) {
            obj["name"] = fieldName
          } else {
            obj["name"] = "Sub Account"
          }
          obj["value"] = this.getProviderGroupName(this.selectedRuleCollection.ownerId)
          this.ruleCollectionDetails.push(obj)
        }
      })
    },

    /**
    * saveTitle - Save changes made to title
    * @param {string} value
    */
    saveField(value, fieldName) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let ruleCollectionObjToUpdate = this.$lodash.cloneDeep(this.selectedRuleCollectionOriginal)
          let valueChanged = false
          if (fieldName === "enabled") {
            ruleCollectionObjToUpdate.disabled = !value
            valueChanged = !(ruleCollectionObjToUpdate.disabled === this.selectedRuleCollectionOriginal.disabled)
          } else {
            value = this.$lodash.isNull(value) ? "" : value
            ruleCollectionObjToUpdate[fieldName] = value
            valueChanged = !(ruleCollectionObjToUpdate[fieldName] === this.selectedRuleCollectionOriginal[fieldName])
          }
          // Update only when the value has changed
          if (valueChanged) {
            ruleCollectionObjToUpdate = this.$lodash.omit(ruleCollectionObjToUpdate, ["_added", "_enabled", "_updated"])
            this.updateRuleCollection(ruleCollectionObjToUpdate)
          }
        } else {
          // Clickingon "clearable" icon sets the value to null
          let fieldObjIndex = this.$lodash.findIndex(this.ruleCollectionDetails, { "name": fieldName })
          // Revert to original value
          let originalObj = {
            name: fieldName,
            value: this.selectedRuleCollectionOriginal[fieldName]
          }
          // NOTE: This might seem tricky but, this code is trying to addresss the reactivity issues related to vue
          // when dealing with arrays. We are assigning a new array instead of modifying the array
          let ruleCollectionDetailsCopy = this.$lodash.cloneDeep(this.ruleCollectionDetails)
          this.ruleCollectionDetails = [] // to help with reactivity issue
          ruleCollectionDetailsCopy.splice(fieldObjIndex, 1, originalObj)
          this.$nextTick(() => {
            this.ruleCollectionDetails = ruleCollectionDetailsCopy
          })
        }
      })
    },

    /**
     *updateRuleSetsSequence-Update Rules Sequence within ruleSet
     */
    updateRuleSetsSequence() {
      this.updatingRuleCollection = true
      let ruleCollectionObjToUpdate = this.$lodash.cloneDeep(this.selectedRuleCollectionOriginal)
      ruleCollectionObjToUpdate.items = this.getRuleCollectionRuleSetGUIDs()
      ruleCollectionObjToUpdate = this.$lodash.omit(ruleCollectionObjToUpdate, ["_added", "_enabled", "_updated"])
      this.updateRuleCollection(ruleCollectionObjToUpdate)
    },

    /**
     * getRuleCollectionRuleSetGUIDs - Retrieves just the rule ids required for create / update
     */
    getRuleCollectionRuleSetGUIDs() {
      return this.$lodash.map(this.ruleSets, "guid")
    },

    /**
     * Cancels inline editing and resets the validation
     */
    cancelInlineEdit() {
      this.$validator.reset()
    },

    /**
     * updateRuleCollection - update the rule set
     * @param {object} ruleCollectionObj
     */
    updateRuleCollection(ruleCollectionObj) {
      this.updatingRuleCollection = true
      metadataRulesDataService.updateRuleCollection(ruleCollectionObj,
        ruleCollectionObj.ownerId,
        this.RULE_MGMT_DATA_SERVICE_URL)
        .then(() => {
          this.resetData()
          // Show snack bar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.RULE_COLLECTION_UPDATED
          MetadataRulesService.$emit("event:refreshRulesList")
        })
        .catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.errorAlert = true
            this.errorMessage = response.description
            // Re-populate original data
            this.retrieveRuleCollection()
          }
        })
        .finally(() => {
          this.updatingRuleCollection = false
        })
    },
    /**
     * hide - Hide the quick view
     */
    hide() {
      MetadataRulesService.$emit("event:hideRuleQuickView")
      this.resetData()
      this.isVisible = false
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * goToEditView - Navigate to Edit view
     */
    goToEditView() {
      let id = this.selectedRuleCollection.id.split("/").pop()
      let ownerId = this.selectedRuleCollection.ownerId
      this.$router.push({
        name: "ManageRuleCollection",
        params: { id: id },
        query: { account: ownerId }
      })
    },

    /**
     * goToEditView - Navigate to Edit view
     * @param {object} ruleSet
     */
    goToEditRuleSetView(ruleSet) {
      let id = ruleSet.id.split("/").pop()
      let ownerId = ruleSet.ownerId
      this.$router.push({
        name: "ManageRuleSet",
        params: { id: id },
        query: { account: ownerId }
      })
    },

    /**
     * goToRuleEditView - Navigate to Edit view
     * @param {object} rule
     */
    goToEditRuleView(rule) {
      let id = rule.id.split("/").pop()
      let ownerId = rule.ownerId
      this.$router.push({
        name: "ManageRule",
        params: { id: id },
        query: { account: ownerId }
      })
    },

    /**
     * showDeleteDialog -
     */
    showDeleteDialog() {
      this.deleteDialog = true
    },

    /**
     * cancelDelete - close delete dialog
     */
    cancelDelete() {
      this.deleteErrorAlert = false
      this.deleteErrorMessage = ""
      this.deleteDialog = false
    },

    /**
     * deleteRule - Delete selected rule / ruleset / rule collection
     */
    deleteRule() {
      this.deletingRule = true
      let ruleCollectionId = this.selectedRuleCollection.id.split("/").pop()
      metadataRulesDataService
        .deleteRuleCollection(ruleCollectionId,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then(() => {
          this.deleteDialog = false
          // Show Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.DELETE_SUCCESS + this.selectedRuleCollection.title
          MetadataRulesService.$emit("event:refreshRulesList")
        }).catch((error) => {
          let isServerError = utils.isMPXError(error)
          if (isServerError) {
            this.deleteErrorAlert = true
            this.deleteErrorMessage = error.response.data.description
          }
        })
        .finally(() => {
          this.deletingRule = false
        })
    },
    /**
     * openRuleQuickView - Open rule quick view in dialog
     */
    openRuleQuickView(ruleObj) {
      this.ruleQuickViewDialog = true
      MetadataRulesService.$emit("event:showRuleQuickViewDialog", ruleObj)
    },

    /**
     * closeRuleQuickView - close the dialog view of rule quick view
     */
    closeRuleQuickView() {
      this.ruleQuickViewDialog = false
    },

    /**
     * openRuleSetQuickView - Open ruleset quick view in dialog
     */
    openRuleSetQuickView(ruleSetObj) {
      this.ruleSetQuickViewDialog = true
      MetadataRulesService.$emit("event:showRuleSetQuickViewDialog", ruleSetObj)
    },

    /**
     * closeRuleSetQuickView - close the dialog view of rule set quick view
     */
    closeRuleSetQuickView() {
      this.ruleSetQuickViewDialog = false
    },

    /**
     * showTestRuleModal
     */
    showTestRuleModal() {
      this.ruleObjectToTest = this.selectedRuleCollection
      this.ruleTestDialog = true
    },

    /**
     * showCopyRuleModal
     */
    showCopyRuleModal() {
      this.ruleObjectToCopy = this.selectedRuleCollectionOriginal
      this.ruleCopyDialog = true
    },

    /**
     * showOverrideRuleModal
     */
    showOverrideRuleModal() {
      this.ruleObjectToOverride = this.selectedRuleCollectionOriginal
      this.ruleOverrideDialog = true
    },

    /**
     * getOwnerName
     * @param {stirng} ownerId
     */
    getOwnerName(ownerId) {
      if (this.IS_POLARIS) {
        return MetadataRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.providerGroups, true)
      } else {
        return MetadataRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.mpxSubAccounts, false)
      }
    },

    /**
     * getOwnerName
     * @param {stirng} secondaryOwner
     */
    getProviderName(secondaryOwner) {
      return MetadataRulesService.getProviderName(secondaryOwner)
    },

    /**
     * getProviderGroupName
     * @param {stirng} ownerId
     */
    getProviderGroupName(ownerId) {
      if (this.IS_POLARIS) {
        return MetadataRulesService.getProviderGroupName(ownerId, this.mpxParentAccount.id, this.providerGroups, true)
      } else {
        return MetadataRulesService.getProviderGroupName(ownerId, this.mpxParentAccount.id, this.mpxSubAccounts, false)
      }
    }
  },
  filters: {
    ownerLabel(value) {
      return MetadataRulesService.getOwnerLabel(value)
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    MetadataRulesService.$on("event:showRuleCollectionQuickView", this.show)
    MetadataRulesService.$on("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    MetadataRulesService.$on("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
  },
  beforeDestroy() {
    MetadataRulesService.$off("event:showRuleCollectionQuickView", this.show)
    MetadataRulesService.$off("event:hideRuleQuickViewDialog", this.closeRuleQuickView)
    MetadataRulesService.$off("event:hideRuleSetQuickViewDialog", this.closeRuleSetQuickView)
  }
}
</script>

<style lang="scss" scoped>
.rule-details {
  min-height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/RuleCollection/RuleCollectionQuickView.vue